<div class = "row">
  <div class = "col-lg-12 mt-5 mb-2">
    <div class="header-title">
      {{'' | i18n: 'help-and-support'}}
    </div>
  </div>
</div>

<div class = "row">
  <div class = "col-lg-12">
    <div class="header-subtitle">{{'' | i18n: 'help-header-1'}}</div>
    <div class="body-text">
      {{'' | i18n: 'help-text-1'}}
    </div>

    <div class="header-subtitle">{{'' | i18n: 'help-header-2'}}</div>
    <div class="body-text">
      {{'' | i18n: 'help-text-2'}}
    </div>

    <div class="header-subtitle">{{'' | i18n: 'help-header-3'}}</div>
    <div class="body-text">
      {{'' | i18n: 'help-text-3'}}
    </div>

    <div class="header-subtitle">{{'' | i18n: 'help-header-4'}}</div>
    <div class="body-text">
      {{'' | i18n: 'help-text-4'}}
    </div>

    <div class="header-subtitle">{{'' | i18n: 'help-header-5'}}</div>
    <div class="body-text">
      {{'' | i18n: 'help-text-5'}}
    </div>
  </div>
</div>

